// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 681) return "static/css/681.2cf290e133f62863c7e8.lib.css";
	if (chunkId === 826) return "static/css/826.76256afdccd050065c16.css";
	// return url for filenames based on template
	return undefined;
};